import {
  apiGet,
  apiPost,
  apiDelete,
  apiPostFormData,
  apiPutFormData,
  apiUpdate,
  apiPatch,
} from "./apiHelper";

const employeeAPI = {
  getAllEmployees: (onSuccess, onError) => {
    return apiGet("/employee/get-all-employee/", onSuccess, onError);
  },

  getActiveEmployees: (onSuccess, onError) => {
    return apiGet("/employee/active-employees/", onSuccess, onError);
  },

  getEmployeeById: (id, onSuccess, onError) => {
    return apiGet(`/employee/get-employee/${id}/`, onSuccess, onError);
  },

  postEmployee: (formData, onSuccess, onError) => {
    return apiPostFormData(
      "/employee/post-employee/",
      formData,
      onSuccess,
      onError
    );
  },

  getAllDepartments: (onSuccess, onError) => {
    return apiGet("/employee/get-departments/", onSuccess, onError);
  },

  getAllRoles: (onSuccess, onError) => {
    return apiGet("/employee/get-roles/", onSuccess, onError);
  },

  deleteProfilePicture: (id, onSuccess, onError) => {
    return apiDelete(`/employee/delete-profile/${id}/`, onSuccess, onError);
  },

  updateEmployee: (id, statusData, onSuccess, onError) => {
    return apiPutFormData(
      `/employee/update-employee/${id}/`,
      statusData,
      onSuccess,
      onError
    );
  },

  updateEmployeeStatus: (id, statusData, onSuccess, onError) => {
    return apiPatch(
      `/employee/employee-status/${id}/`,
      statusData,
      onSuccess,
      onError
    );
  },
};

export default employeeAPI;
